module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_8.f6f1a076.png";